import { IFormFieldOption } from "./form-field-option";

export interface IFormField {
  code?: string;
  label?: string;
  type?: string;
  description?: string;
  display?: string;
  defaultValue?: string;
  entityField?: string;
  options?: IFormFieldOption[];
  externalApiField?: string;
}

export const formFieldTypesWithOptions = ["SELECT", "CHECKBOX", "RADIO_BUTTON"];

export const formFieldTypes = [
  "STRING",
  "INTEGER",
  "DECIMAL",
  "BOOLEAN",
  "DATETIME",
  "SELECT",
  "CHECKBOX",
  "RADIO_BUTTON",
  "ROLE",
];

export const formFieldDisplays = ["REQUIRED", "OPTIONAL", "HIDDEN"];

export const formFieldEntityFields = [
  "NAME",
  "GENDER",
  "BIRTH_DATE",
  "EMAIL",
  "STREET_ADDRESS",
  "STREET_NUMBER",
  "ADDRESS_COMPLEMENT",
  "ZIP_CODE",
  "DISTRICT",
  "CITY",
  "STATE",
  "HOME_PHONE",
  "MOBILE_PHONE",
  "COMMERCIAL_PHONE",
  "ALLOWS_MAIL",
  "ALLOWS_EMAIL",
  "ALLOWS_SMS",
  "ALLOWS_PHONE_CALLS",
  "ICD",
  "PRESCRIBER_COUNCIL_REGISTER",
  "PRESCRIBER_PROFESSIONAL_COUNCIL",
  "PRESCRIBER_COUNCIL_STATE",
];
